var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showBattleModal
    ? _c(
        "div",
        { staticClass: "battle-modal", on: { click: _vm.closeModal } },
        [
          _c(
            "div",
            {
              staticClass: "battle-container",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "battle-combatants" }, [
                _c("div", { staticClass: "combatant player-combatant" }, [
                  _c("div", { staticClass: "character-info" }, [
                    _c("div", { staticClass: "name-section" }, [
                      _c("h4", { staticClass: "character-name" }, [
                        _vm._v(_vm._s(_vm.playerName)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "details-section" }, [
                      _c("div", { staticClass: "player-details" }, [
                        _c("p", { staticClass: "player-description" }, [
                          _vm._v(
                            "灵力值: " +
                              _vm._s(_vm.battleState.player.mana || 0)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "player-level" }, [
                          _vm._v(
                            "境界: " +
                              _vm._s(
                                _vm.getPlayerRealmName(
                                  _vm.battleState.player.realm || 0
                                )
                              )
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "health-section" }, [
                      _c("div", { staticClass: "health-bar" }, [
                        _c("div", {
                          staticClass: "health-fill",
                          style: { width: _vm.playerHealthPercent + "%" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "health-text" }, [
                          _vm._v(
                            _vm._s(_vm.battleState.player.currentQi) +
                              "/" +
                              _vm._s(_vm.battleState.player.maxQi)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.battleState.player.effects.length > 0
                        ? _c(
                            "div",
                            { staticClass: "effects" },
                            _vm._l(
                              _vm.battleState.player.effects,
                              function (effect) {
                                return _c(
                                  "span",
                                  { key: effect.type, staticClass: "effect" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.getEffectDisplay(effect)) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "combatant beast-combatant" }, [
                  _c("div", { staticClass: "character-info" }, [
                    _c("div", { staticClass: "name-section" }, [
                      _c("h4", { staticClass: "character-name" }, [
                        _vm._v(_vm._s(_vm.battleState.beast.name)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "details-section" }, [
                      _c("div", { staticClass: "beast-details" }, [
                        _c("p", { staticClass: "beast-description" }, [
                          _vm._v(_vm._s(_vm.battleState.beast.description)),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "beast-level" }, [
                          _vm._v(
                            "境界: " +
                              _vm._s(
                                _vm.getBeastRealmName(
                                  _vm.battleState.beast.realm
                                )
                              ) +
                              " 等级: " +
                              _vm._s(_vm.battleState.beast.level)
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "health-section" }, [
                      _c("div", { staticClass: "health-bar" }, [
                        _c("div", {
                          staticClass: "health-fill beast-health",
                          style: { width: _vm.beastHealthPercent + "%" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "health-text" }, [
                          _vm._v(
                            _vm._s(_vm.battleState.beast.currentQi) +
                              "/" +
                              _vm._s(_vm.battleState.beast.maxQi)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.battleState.beast.effects.length > 0
                        ? _c(
                            "div",
                            { staticClass: "effects" },
                            _vm._l(
                              _vm.battleState.beast.effects,
                              function (effect) {
                                return _c(
                                  "span",
                                  { key: effect.type, staticClass: "effect" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.getEffectDisplay(effect)) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "battle-log" }, [
                _c(
                  "div",
                  { staticClass: "log-content" },
                  _vm._l(_vm.battleState.log, function (log, index) {
                    return _c("div", { key: index, staticClass: "log-entry" }, [
                      _vm._v(
                        "\n          " + _vm._s(log.message) + "\n        "
                      ),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "battle-footer" }, [
                !_vm.battleState.battleResult
                  ? _c("div", { staticClass: "battle-controls" }, [
                      _vm.battleState.isPlayerTurn
                        ? _c("div", { staticClass: "player-turn" }, [
                            _c("h4", [_vm._v("你的回合")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "action-buttons" },
                              [
                                _vm._l(_vm.playerSkills, function (skill) {
                                  return _c(
                                    "button",
                                    {
                                      key: skill,
                                      staticClass: "skill-button",
                                      on: {
                                        click: function ($event) {
                                          return _vm.useSkill(skill)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(skill) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "flee-button",
                                    on: { click: _vm.attemptFlee },
                                  },
                                  [_vm._v("逃跑")]
                                ),
                              ],
                              2
                            ),
                          ])
                        : _c("div", { staticClass: "beast-turn" }, [
                            _c("p", [_vm._v("妖兽正在行动...")]),
                          ]),
                    ])
                  : _c("div", { staticClass: "battle-result" }, [
                      _vm.battleState.battleResult === "victory"
                        ? _c("h4", [_vm._v("战斗胜利！")])
                        : _vm.battleState.battleResult === "defeat"
                        ? _c("h4", [_vm._v("战斗失败！")])
                        : _vm.battleState.battleResult === "fled"
                        ? _c("h4", [_vm._v("成功逃脱！")])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close-button",
                          on: { click: _vm.closeModal },
                        },
                        [_vm._v("关闭")]
                      ),
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "turn-info" }, [
                  _vm._v(
                    "\n        第 " +
                      _vm._s(_vm.battleState.turn) +
                      " 回合\n      "
                  ),
                ]),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "battle-header" }, [
      _c("h3", [_vm._v("妖兽战斗")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vs-container" }, [
      _c("div", { staticClass: "vs-indicator" }, [_vm._v("VS")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }